import React from 'react';

const UserAccountContext = React.createContext();

export { 
    UserAccountContext
};